import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

import type { ShortUrlOgMetaRq, ShortUrlAppendTagToUrlsRq, ShortUrlRemoveTagFromRq } from '../api-generator/aggr/api'
import type { CsvExportResponse } from '@/types/shortUrl'

const feShortUrlsApi = createAggrApiInstance(aggr.FrontendShortUrlsApi)

/** 查詢短網址列表 */
export const queryAllFEShortUrls = async (reqData: aggr.ShortUrlQueryAllRq) => {
  const res = await handleApiStatus(() => feShortUrlsApi.shorturlsQueryall(reqData))
  return res
}

/** 查詢短網址列表總筆數 */
export const queryAllFEShortUrlTotalCount = async (reqData: aggr.ShortUrlQueryAllSubtotalRq) => {
  const res = await handleApiStatus(() => feShortUrlsApi.shorturlsQueryallsubtotal(reqData))
  return res
}

/** 查詢數據標籤 */
export const querySubTags = async (companyUuId: string, companyOrganizationUuid: string) => {
  const res = await handleApiStatus(() => feShortUrlsApi.shorturlsQuerysubtags(companyUuId, companyOrganizationUuid))
  return res
}

/** 查詢短網址的 OG Meta 資訊 */
export const queryOgMeta = async (shortUrlOgMetaRq: ShortUrlOgMetaRq) => {
  const res = await handleApiStatus(() => feShortUrlsApi.shorturlsGetogmeta(shortUrlOgMetaRq))
  return res
}

/** 新增短網址 */
export const createShortUrl = async (reqData: aggr.ShortUrlCreateRq) => {
  const res = await handleApiStatus(() => feShortUrlsApi.shorturlsCreate(reqData))
  return res
}

/** 更新短網址 */
export const updateShortUrl = async (reqData: aggr.ShortUrlUpdateRq) => {
  const res = await handleApiStatus(() => feShortUrlsApi.shorturlsUpdate(reqData))
  return res
}

/** 輸出所有短網址為 CSV 檔案*/
export const exportAll = async (reqData: aggr.ShortUrlExportAllRq): Promise<CsvExportResponse> => {
  const res = await handleApiStatus(() => feShortUrlsApi.shorturlsExportall(reqData))
  return res as unknown as CsvExportResponse
}

/** 輸出所選短網址為 CSV 檔案*/
export const exportSelectedShortUrls = async (reqData: aggr.ShortUrlExportSelectedRq): Promise<CsvExportResponse> => {
  const res = await handleApiStatus(() => feShortUrlsApi.shorturlsExportselected(reqData))
  return res as unknown as CsvExportResponse
}

/** 刪除短網址 */
export const deleteShortUrls = async (reqData: aggr.ShortUrlDeleteRq) => {
  const res = await handleApiStatus(() => feShortUrlsApi.shorturlsDelete(reqData))
  return res
}

/** 查詢短網址詳細資訊 */
export const fetchShortUrlDetail = async (reqData: aggr.ShortUrlQueryRq) => {
  const res = await handleApiStatus(() => feShortUrlsApi.shorturlsQuery(reqData))
  return res
}

/** 對短網址新增類別標籤 */
export const appendTagToUrls = async (reqData: ShortUrlAppendTagToUrlsRq) => {
  const res = await handleApiStatus(() => feShortUrlsApi.shorturlsAppendtagtourls(reqData))
  return res
}

/** 對短網址移除類別標籤 */
export const removeTagFromUrls = async (reqData: ShortUrlRemoveTagFromRq) => {
  const res = await handleApiStatus(() => feShortUrlsApi.shorturlsRemovetagfromurls(reqData))
  return res
}
